import React from 'react';
import './Pager.scss';

const Pager = ({total, itemsPerPage, currentPage, handleClick}) => {
    const totalPages = Math.ceil(total / itemsPerPage);

    if (total <= itemsPerPage) {
        return (
            <div className="pager">
                <div>
                    <div className="results">Showing 1 to {total} of {total} (1 Page)</div>
                </div>
            </div>
        );
    }

    const renderFirstButton = () => {
        if (currentPage > 1) {
            return <button onClick={() => handleClick(1)}>|&lt;</button>;
        }
        return null;
    };
    const renderPrevButton = () => {
        if (currentPage > 1) {
            return <button onClick={() => handleClick(currentPage - 1)}>&lt;</button>;
        }
        return null;
    };
    const renderNextButton = () => {
        if (currentPage < totalPages) {
            return <button onClick={() => handleClick(currentPage + 1)}>&gt;</button>;
        }
        return null;
    };
    const renderLastButton = () => {
        if (currentPage < totalPages) {
            return <button onClick={() => handleClick(totalPages)}>&gt;|</button>;
        }
        return null;
    };
    const renderPageButtons = () => {
        const buttons = [];
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, startPage + 4);

        for (let i = startPage; i <= endPage; i++) {
            const isActive = i === currentPage ? 'active' : '';
            buttons.push(<button key={i} className={isActive} onClick={() => handleClick(i)}>{i}</button>);
        }

        return buttons;
    };

    return (
        <div className="pager">
            <div>
                <div className="links">
                    {renderFirstButton()}
                    {renderPrevButton()}
                    {renderPageButtons()}
                    {renderNextButton()}
                    {renderLastButton()}
                </div>
                <div
                    className="results">Showing {(currentPage - 1) * itemsPerPage + 1} to {(currentPage - 1) * itemsPerPage + itemsPerPage} of {total} ({totalPages} Pages)
                </div>
            </div>
        </div>
    );
}

export default Pager;
